import { Component, OnDestroy, OnInit } from '@angular/core'
import { isNotNullable, Product, ProductReference, ProductReferenceService } from '@spartacus/core'
import { CurrentProductService } from '@spartacus/storefront'
import { Observable, Subscription } from 'rxjs'
import { distinctUntilChanged, filter, first, map, shareReplay, switchMap, tap } from 'rxjs/operators'
import { DataAnalyticsClickSource, DataAnalyticsEventLabel, MbConstants } from '../../mb-constants'

@Component({
  selector: 'mb-related-products-component',
  templateUrl: './related-products.component.html',
  styleUrls: ['./related-products.component.scss']
})
export class RelatedProductsComponent implements OnInit, OnDestroy {

  dataAnalyticsClickSource = DataAnalyticsClickSource.PDP_CROSS_SELLING
  dataAnalyticsEventLabel = DataAnalyticsEventLabel.ADD_TO_CART
  constants = MbConstants
  product$: Observable<Product> = this.currentProductService.getProduct().pipe(
    filter(isNotNullable),
    shareReplay({ bufferSize: 1, refCount: true })
  )
  references$: Observable<ProductReference[]> | undefined
  localTitle$ = this.product$.pipe(
    map(product => product?.nameHtml),
    filter(isNotNullable),
  )
  title = 'mbproduct.relatedProductsFor'

  subscription = new Subscription()

  constructor (protected currentProductService: CurrentProductService,
              protected productReferenceService: ProductReferenceService) {
  }

  ngOnInit (): void {
    const productCode$ = this.product$.pipe(
      map(product => product?.originalCode),
      filter(isNotNullable),
      distinctUntilChanged(),
      tap((_) => this.productReferenceService.cleanReferences())
    )
    this.references$ = productCode$.pipe(
      switchMap(productCode => this.productReferenceService.getProductReferences(productCode, this.constants.RELATED).pipe(
        filter(references => references.length !== 0),
        /* this first() is crucial because the product references store only stores one instance of references, which
          * is always the most recently requested ones. We have to "disconnect" from the store after the first emit. */
        first()
      )),
    )
    this.subscription?.add(productCode$.subscribe(
      productCode => this.productReferenceService.loadProductReferences(productCode, this.constants.RELATED)
    ))
  }
  ngOnDestroy (): void {
    this.subscription.unsubscribe()
  }
}
